import Vue from 'vue'

Vue.mixin({
  data: () => ({
    globalRules: {
      required: v => !!v || 'Required',
      fileInput: [
        v => !!v || 'File is required',
        v => (v && v.size > 0) || 'File is required'
      ]
    }
  })
})
